import { Component } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'paypal-donation-control',
    templateUrl: 'paypal-donation.control.html',
    standalone: false,
})
export class PaypalDonationControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.hostedButtonId = this.settings.paypalHostedButtonId;
    }

    public hostedButtonId: string;
}
